import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../environments/environment';


@Component({
  selector: 'app-appconnect',
  templateUrl: './appconnect.component.html',
  styleUrls: ['./appconnect.component.css']
})
export class AppconnectComponent implements OnInit {

  public stravaImg = "../../assets/images/btn_strava.png";
  public stravaConnect = false;
  constructor(private http: HttpClient,  private router: Router, public _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.stravaConnect = (localStorage.getItem("maplerace_stravaConnect")==="true");
  }

  async unregister(){
    let that = this;
    const httpOptions = {
			headers: new HttpHeaders({ 'Content-Type': 'application/json' , 'x-auth-token' : localStorage.getItem("maplerace_auth") })
		};

    await this.http.get<any>(environment.endpoint + "/strava/deauthorize", httpOptions).toPromise().then(value => {
        if(value){
          localStorage.setItem("maplerace_stravaConnect", "false");  
          that._snackBar.open('Your strava account has been unlinked', 'Close', {
            duration: 3000
          });
          that.router.navigateByUrl('/dashboard');
        }else{
          that._snackBar.open('An error occured', 'Close', {
            duration: 3000
            });
        }

    }).catch((error) => {
      that._snackBar.open('An error occured', 'Close', {
        duration: 3000
        });
    });
  }

}
